<template>
  <span class="p-badge" :style="{ color, background: color + '22' }">{{ text }}</span>
</template>

<script>
export default {
  name: "PortalBadge",
  props: {
    text: { type: String, default: "" },
    color: { type: String, default: "#64748b" },
  },
};
</script>

<style scoped>
.p-badge {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 6px;
  white-space: nowrap;
}
</style>
